module.exports = __webpack_public_path__ + "static/gooseberry-and-waves-c460dc75a349977f3a8893d82edad860.png";